// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2rcre","confirm":"Cards_confirm__CsV4w","recovered":"Cards_recovered__3R3u8","death":"Cards_death__2Tg3t"};